var AddressesMixin = {
  methods: {
    getFullAddress(jsonAddress) {
      let fullAddress = "";
      if (jsonAddress.tipoDireccion) fullAddress += jsonAddress.tipoDireccion + " ";
      if (jsonAddress.direccion) fullAddress += jsonAddress.direccion + " ";
      if (jsonAddress.localidad) fullAddress += jsonAddress.localidad + " ";
      if (jsonAddress.codigoPostal) fullAddress += jsonAddress.codigoPostal + " ";
      if (jsonAddress.provincia) fullAddress += jsonAddress.provincia + " ";
      if (jsonAddress.pais) fullAddress += jsonAddress.pais + " ";
      return fullAddress;
    }
  }
};
export default AddressesMixin;


/*
codigoPostal
direccion
pais
localidad
provincia
tipoDireccion
*/